export default "__VITE_ASSET__DLg9BCl0__"